import { render } from "./pageHead.vue?vue&type=template&id=b60459ba&scoped=true&ts=true"
import script from "./pageHead.vue?vue&type=script&lang=ts"
export * from "./pageHead.vue?vue&type=script&lang=ts"

import "./pageHead.vue?vue&type=style&index=0&id=b60459ba&lang=scss&scoped=true"

import exportComponent from "E:\\project\\help-center\\help-center-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b60459ba"]])

export default __exports__